import React from 'react';
import { observer } from 'src/utils/mobx-react';
import Header from 'src/components/Header';
import { LayoutWrapper, MainContainer } from 'src/domains/layouts/shared/layout/Layout.style';
import { CmsPageContent } from 'src/layouts/CmsPage/CmsPageContent';

export const CmsPageV2 = observer('CmsPage', (): React.ReactElement => {
    return (
        <LayoutWrapper>
            <MainContainer>
                <Header />
                <CmsPageContent />
            </MainContainer>
        </LayoutWrapper>
    );
});
